import { createContext, useCallback, useContext, useState } from "react";
import type { ReactNode } from "react";
import type { AnyEntity } from "../api/types";

interface UIState {
  selectedEntity: AnyEntity | null;
  openEntity: (e: AnyEntity) => void;
  closeEntity: () => void;
  searchQuery: string;
  setSearchQuery: (q: string) => void;
  declareOpen: boolean;
  setDeclareOpen: (b: boolean) => void;
  helpOpen: boolean;
  setHelpOpen: (b: boolean) => void;
}

const Ctx = createContext<UIState | null>(null);

export function UIProvider({ children }: { children: ReactNode }) {
  const [selectedEntity, setSelected] = useState<AnyEntity | null>(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [declareOpen, setDeclareOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);

  const openEntity = useCallback((e: AnyEntity) => setSelected(e), []);
  const closeEntity = useCallback(() => setSelected(null), []);

  return (
    <Ctx.Provider value={{
      selectedEntity, openEntity, closeEntity,
      searchQuery, setSearchQuery,
      declareOpen, setDeclareOpen,
      helpOpen, setHelpOpen,
    }}>
      {children}
    </Ctx.Provider>
  );
}

export function useUI() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useUI() must be used inside <UIProvider>");
  return ctx;
}
